/** @format */

export const deleteCookie = () => {
  const pastDate = new Date(0);
  const expires = `expires=${pastDate.toUTCString()}`;
  const domainAttr = `domain=.layline.live`;
  document.cookie = `ssoToken=; ${expires}; ${domainAttr}; path=/;`;
};

export function setCookie(value) {
  const date = new Date();
  date.setTime(date.getTime() + 3600000); // Convert days to milliseconds
  const expires = `expires=${date.toUTCString()}`;
  const domainAttr = `domain=.layline.live`;
  document.cookie = `ssoToken=${value}; ${expires}; ${domainAttr}; path=/;`;
}

export function getCookie(name) {
  const cookies = document?.cookie?.split("; ");
  for (const cookie of cookies) {
    const [key, value] = cookie?.split("=");
    if (key === name) return value;
  }
  return null;
}
